import { Film } from '../types'

export const mockFilms: Film[] = [
  {
    id: '1',
    title: 'Летят журавли',
    year: 1957,
    posterUrl:
      'https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&q=80&w=800',
    stillUrls: [
      'https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1517604931442-710536443883?auto=format&fit=crop&q=80&w=800',
    ],
    director: 'Михаил Калатозов',
    writers: ['Виктор Розов'],
    cast: ['Татьяна Самойлова', 'Алексей Баталов', 'Василий Меркурьев'],
    genreTags: ['Драма', 'Военный'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Черно-белый',
    duration: 95,
    releaseDateVE: '12.10.1957',
    catalogNumber: '2384',
    descriptionExcerpt:
      'Трагическая история двух влюбленных, которых война разлучила навсегда.',
    descriptionFull:
      'Фильм рассказывает о людях, в чьи судьбы безжалостно вторглась война. Не все смогли с честью вынести это испытание. В центре киноповести — трагическая история двух влюбленных, которых война разлучила навсегда.',
  },
  {
    id: '2',
    title: 'Бриллиантовая рука',
    year: 1968,
    posterUrl:
      'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?auto=format&fit=crop&q=80&w=800',
    stillUrls: [
      'https://images.unsplash.com/photo-1594909122845-11baa439b7bf?auto=format&fit=crop&q=80&w=800',
    ],
    director: 'Леонид Гайдай',
    writers: ['Морис Слободской', 'Яков Костюковский', 'Леонид Гайдай'],
    cast: ['Юрий Никулин', 'Андрей Миронов', 'Анатолий Папанов'],
    genreTags: ['Комедия', 'Приключения'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 94,
    releaseDateVE: '28.04.1969',
    catalogNumber: '3102',
    descriptionExcerpt:
      'Эксцентрическая комедия о скромном служащем, вступившем в поединок с шайкой контрабандистов.',
    descriptionFull:
      'Кинороман из жизни контрабандистов с прологом и эпилогом. В южном городке орудует шайка «валютчиков», возглавляемая Шефом и его помощником Графом. Скромный советский служащий и примерный семьянин Семен Семенович Горбунков отправляется в зарубежный круиз на теплоходе, где ему предстоит столкнуться с невероятными приключениями.',
  },
  {
    id: '3',
    title: 'Солярис',
    year: 1972,
    posterUrl:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800',
    stillUrls: [
      'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&q=80&w=800',
    ],
    director: 'Андрей Тарковский',
    writers: ['Фридрих Горенштейн', 'Андрей Тарковский'],
    cast: ['Донатас Банионис', 'Наталья Бондарчук', 'Юри Ярвет'],
    genreTags: ['Фантастика', 'Драма'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 169,
    releaseDateVE: '05.02.1973',
    catalogNumber: '4521',
    descriptionExcerpt:
      'Философская фантастика о контакте с иным разумом и глубинах человеческой совести.',
    descriptionFull:
      'На космическую станцию, сотрудники которой давно и тщетно пытаются сладить с загадкой планеты Солярис, покрытой Океаном, прибывает новый обитатель, психолог Крис Кельвин. Ему предстоит разобраться в странных сообщениях, поступающих со станции, и закрыть её.',
  },
  {
    id: '4',
    title: 'Иван Васильевич меняет профессию',
    year: 1973,
    posterUrl:
      'https://images.unsplash.com/photo-1543536448-d209d2d15a1e?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Леонид Гайдай',
    writers: ['Владлен Бахнов', 'Леонид Гайдай'],
    cast: ['Александр Демьяненко', 'Юрий Яковлев', 'Леонид Куравлёв'],
    genreTags: ['Комедия', 'Фантастика'],
    ageCategory: '6+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 88,
    releaseDateVE: '17.09.1973',
    catalogNumber: '4890',
    descriptionExcerpt:
      'Инженер-изобретатель Тимофеев сконструировал машину времени и открыл портал в XVI век.',
    descriptionFull:
      'Инженер-изобретатель Тимофеев сконструировал машину времени, которая соединила его квартиру с далеким шестнадцатым веком - точнее, с палатами государя Ивана Грозного. Туда-то и попадают тезка царя пенсионер-общественник Иван Васильевич Бунша и квартирный вор Жорж Милославский.',
  },
  {
    id: '5',
    title: 'Сталкер',
    year: 1979,
    posterUrl:
      'https://images.unsplash.com/photo-1605806616949-1e87b487bc2a?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Андрей Тарковский',
    writers: ['Аркадий Стругацкий', 'Борис Стругацкий'],
    cast: ['Александр Кайдановский', 'Анатолий Солоницын', 'Николай Гринько'],
    genreTags: ['Фантастика', 'Драма', 'Притча'],
    ageCategory: '16+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 163,
    releaseDateVE: '19.05.1980',
    catalogNumber: '5612',
    descriptionExcerpt:
      'Путешествие в таинственную Зону, где исполняются самые заветные желания.',
    descriptionFull:
      'В вымышленном времени и пространстве герои, называемые Писателем и Профессором, отправляются в опасное путешествие в Зону — место, где происходят странные явления и где, по слухам, существует Комната, исполняющая желания. Их ведет проводник — Сталкер.',
  },
  {
    id: '6',
    title: 'Мимино',
    year: 1977,
    posterUrl:
      'https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Георгий Данелия',
    writers: ['Резо Габриадзе', 'Виктория Токарева', 'Георгий Данелия'],
    cast: ['Вахтанг Кикабидзе', 'Фрунзик Мкртчян', 'Елена Проклова'],
    genreTags: ['Комедия', 'Драма'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 92,
    releaseDateVE: '27.03.1978',
    catalogNumber: '5100',
    descriptionExcerpt:
      'История провинциального летчика, мечтающего о большой авиации.',
    descriptionFull:
      'Валико Мизандари по прозвищу «Мимино» — летчик местных авиалиний в Грузии. Однажды он встречает своего бывшего однокурсника, который управляет сверхзвуковым лайнером международных авиалиний, и решает изменить свою жизнь.',
  },
  {
    id: '7',
    title: 'Кин-дза-дза!',
    year: 1986,
    posterUrl:
      'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Георгий Данелия',
    writers: ['Резо Габриадзе', 'Георгий Данелия'],
    cast: ['Станислав Любшин', 'Евгений Леонов', 'Юрий Яковлев'],
    genreTags: ['Фантастика', 'Комедия', 'Антиутопия'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 135,
    releaseDateVE: '01.12.1986',
    catalogNumber: '6789',
    descriptionExcerpt:
      'Прораб Владимир Николаевич Машков и не подозревал, что обычный путь в гастроном обернется межгалактическим путешествием.',
    descriptionFull:
      'Прораб Владимир Николаевич Машков и не подозревал, что обычный путь в гастроном за хлебом и макаронами обернется межгалактическим путешествием. А все эта встреча со студентом в кроличьей шапке с большой сумкой и с каким-то маленьким устройством — «машинкой перемещения».',
  },
  {
    id: '8',
    title: 'Служебный роман',
    year: 1977,
    posterUrl:
      'https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Эльдар Рязанов',
    writers: ['Эмиль Брагинский', 'Эльдар Рязанов'],
    cast: ['Андрей Мягков', 'Алиса Фрейндлих', 'Светлана Немоляева'],
    genreTags: ['Комедия', 'Мелодрама'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 159,
    releaseDateVE: '26.10.1977',
    catalogNumber: '5230',
    descriptionExcerpt:
      'Лирическая комедия о любви робкого служащего и строгой начальницы.',
    descriptionFull:
      'Анатолий Ефремович Новосельцев, рядовой служащий одного статистического управления, — человек робкий и застенчивый. Для него неплохо бы получить вакантное место зав. отделом, но он не знает, как подступиться к этому делу. Старый приятель Самохвалов советует ему приударить за Людмилой Прокофьевной Калугиной — сухарем в юбке и директором заведения.',
  },
  {
    id: '9',
    title: 'Белое солнце пустыни',
    year: 1970,
    posterUrl:
      'https://images.unsplash.com/photo-1509316975850-ff9c5deb0cd9?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Владимир Мотыль',
    writers: ['Валентин Ежов', 'Рустам Ибрагимбеков'],
    cast: ['Анатолий Кузнецов', 'Павел Луспекаев', 'Спартак Мишулин'],
    genreTags: ['Боевик', 'Приключения', 'Истерн'],
    ageCategory: '12+',
    studio: 'Мосфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 85,
    releaseDateVE: '30.03.1970',
    catalogNumber: '3450',
    descriptionExcerpt:
      'Бесконечная пустыня, боец Сухов, гарем Абдуллы и вопросы Востока, который — дело тонкое.',
    descriptionFull:
      'Действие фильма происходит в начале 1920-х годов на восточном берегу Каспийского моря. Закончилась Гражданская война, но в Средней Азии все еще орудуют банды басмачей. Красноармеец Федор Иванович Сухов возвращается домой через пустыню.',
  },
  {
    id: '10',
    title: 'Человек-амфибия',
    year: 1961,
    posterUrl:
      'https://images.unsplash.com/photo-1580477667995-2b94f01c9516?auto=format&fit=crop&q=80&w=800',
    stillUrls: [],
    director: 'Владимир Чеботарёв',
    writers: ['Акиба Гольбурт', 'Александр Ксенофонтов'],
    cast: ['Владимир Коренев', 'Анастасия Вертинская', 'Михаил Козаков'],
    genreTags: ['Фантастика', 'Мелодрама'],
    ageCategory: '6+',
    studio: 'Ленфильм',
    republic: 'РСФСР',
    color: 'Цветной',
    duration: 96,
    releaseDateVE: '03.01.1962',
    catalogNumber: '2890',
    descriptionExcerpt:
      'Красивая и печальная история любви Ихтиандра и Гуттиэре.',
    descriptionFull:
      'Рыбаки и ловцы жемчуга Буэнос-Айреса напуганы — в море появился таинственный «морской дьявол». Однако хладнокровный делец Педро Зурита, владелец шхуны для ловли жемчуга, решает поймать загадочное существо и заставить его работать на себя.',
  },
]
